import { SETTINGS } from '../../../utils/constants';
import { handlePrice } from '../../../utils/utils';
import { View } from '../../base/View';
export class ProductItemBasket extends View {
    constructor(container, actions) {
        super(container);
        this._title = container.querySelector(SETTINGS.productSettings.title);
        this._index = container.querySelector(SETTINGS.productBasketSettings.id);
        this._price = container.querySelector(SETTINGS.productSettings.price);
        this._button = container.querySelector(SETTINGS.productBasketSettings.buttonDelete);
        if (this._button)
            this._button.addEventListener('click', (evt) => {
                this.container.remove();
                actions === null || actions === void 0 ? void 0 : actions.onClick(evt);
            });
    }
    set title(value) {
        this._title.textContent = value;
    }
    set index(value) {
        this._index.textContent = value.toString();
    }
    set price(value) {
        this._price.textContent = handlePrice(value) + ' синапсов';
    }
}
